export default {
  ticketsForConsumption: [],
  consumptionBatches: []
}
